import React from 'react';
import Typography from '@mui/material/Typography';
import "./style.css"
import { readableColor } from 'polished';
import { colorBrandObject } from '../../../../constants/brandings';
import { formatAmount } from '../../utils/utils';
import { IconButton, Skeleton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";


const KpiCard = ({ title, amount, toolTip }) => {
    return (

        <div className='kpi-card-root border px-3 py-3' style={{ backgroundColor: colorBrandObject?.firstKpiColor }}>
            {
                amount === undefined ? (
                    <>
                        <Skeleton variant="text" />
                        <Skeleton variant="text" />
                        <Skeleton variant="text" />
                    </>
                ) : (
                    <div className='kpi-card-container'>
                        <div className='d-flex align-items-center gap-1' style={{ gap: "0rem" }}>
                            <Typography className="bodyB2SemiBold font-black-high"
                                style={{
                                    // color: readableColor(colorBrandObject?.firstKpiColor),
                                    textTransform: 'capitalize',
                                    fontSize: '0.7rem'
                                }}>
                                {title}
                            </Typography>
                            <span>
                                {toolTip && <Tooltip
                                    title={toolTip}
                                    arrow
                                >
                                    <IconButton
                                        sx={{
                                            "&:hover": { backgroundColor: "transparent" },
                                        }}
                                        disableFocusRipple
                                        disableTouchRipple
                                    >
                                        <InfoOutlinedIcon
                                            sx={{
                                                height: "14px",
                                                width: "14px",
                                                border: "0px",
                                                color: "#000000D9",
                                            }}
                                        />
                                    </IconButton>
                                </Tooltip>}
                            </span>
                        </div>
                        <Typography
                            className="headerH2Bold amountHeading"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "10px",
                                marginBottom: "4px",
                                fontSize: '1.2rem',
                                color: readableColor(colorBrandObject?.firstKpiColor),
                            }}
                        >
                            {formatAmount({ amount: Math.round(amount) })}
                        </Typography>
                    </div>
                )
            }
        </div>
    )
}

export default KpiCard